// const crypto = require('crypto');
import JSEncrypt from 'jsencrypt';
// import sha256 from 'crypto-js/hmac-sha256';
// import md5 from 'crypto-js/md5';

var mPublicKey = "-----BEGIN PUBLIC KEY-----\nMFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBALuCRM5wqGt5Ehhq/pdGHVFZ5kemv5NS\nSaOf6wc0GBJZ4ZBRGsg0SnYsdbb3p3/a9L5IU66b72tWDb89jZur4jUCAwEAAQ==\n-----END PUBLIC KEY-----";
export default {
  encryptRsaPublic: function encryptRsaPublic(string) {
    var crypt = new JSEncrypt();
    crypt.setKey(mPublicKey);
    var enc = crypt.encrypt(string);
    return enc;
  }
};